export default __webpack_public_path__ + "static/media/web_vid.8f6bab42.mp4";